export default {
  SET_REQUEST_COUNT(
    state,
    {
      budgetRequest,
      // menuRequest,
      // agencyMarginRequest,
    },
  ) {
    state.count = {
      ...state.count,
      total: budgetRequest + state.count.mapReportRequest,
      // budgetRequest + menuRequest + agencyMarginRequest + mapReportRequest,
      budgetRequest,
      // menuRequest,
      // agencyMarginRequest,
    }
  },
  SET_MAP_REPORT_REQUEST_COUNT(state, { mapReportRequest }) {
    state.count = {
      ...state.count,
      total: state.count.budgetRequest + mapReportRequest,
      mapReportRequest,
    }
  },
  RESET(state) {
    state.count = {
      total: 0,
      budgetRequest: 0,
      // menuRequest: 0,
      // agencyMarginRequest: 0,
      mapReportRequest: 0,
    }
  },
}
